uic-sidebar {
  bottom: 0;
  height: auto;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  position: fixed;
  top: 0;
  z-index: 80;
}

.uic-sidebar {
  &--align-header {
    top: var(--uic-header-height);
  }

  &--align-footer {
    bottom: 52px;

    @media only screen and (max-width: 1023px) {
      bottom: 39px;
    }
  }

  &--opened,
  &--closing {
    transition: transform 250ms ease-out;
  }

  &--closed {
    display: none;
  }

  &--side-left {
    left: 0;
    right: auto;

    &.uic-sidebar--opening,
    &.uic-sidebar--closing {
      transform: translateX(-110%);
    }
  }

  &--side-right {
    left: auto;
    right: 0;

    &.uic-sidebar--opening,
    &.uic-sidebar--closing {
      transform: translateX(110%);
    }
  }
}
